import { Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

//* utils
import { MtvDataType } from '../../../../models/components/mediaTextVariants'
import { internalLinkHandler } from '../../../../utils/link.utils'

//* components
import { AccordionImage, AccordionItem } from './mediaTextParts'

type Props = {
  mtvData: MtvDataType
  mainImgPath: string
  mainImgAlt: string
}

export const AccordionLayout = ({ mtvData, mainImgPath, mainImgAlt }: Props) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const handleItemClick = (index: number) => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index))
  }

  useEffect(() => {
    handleItemClick(0)
  }, [])

  return (
    <div className="Accordion__Container">
      <div className="Accordion__Content">
        <Grid container spacing={0} className="Column-entries">
          <Grid item sm={12} md={12} lg={5}>
            <div className="Accordion__Content-Left">
              {mtvData.map((tabs, index: number) => {
                const tabImgPath: string = tabs?.media?.image?.file?.url || ''
                const tabImgAlt: string = tabs?.media?.altText || ''

                return (
                  <>
                    <AccordionItem
                      id={index}
                      title={tabs?.title}
                      headline={tabs?.headline}
                      body={tabs?.body}
                      tabImgAlt={tabImgAlt}
                      tabImgPath={tabImgPath}
                      mainImgPath={mainImgPath}
                      mainImgAlt={mainImgAlt}
                      isOpen={activeIndex === index}
                      onClick={() => handleItemClick(index)}
                      ctaLink={
                        tabs?.cta?.internalLink
                          ? internalLinkHandler(tabs?.cta?.internalLink)
                          : tabs?.cta?.externalUrl || ''
                      }
                      ctaText={tabs?.cta?.text || ''}
                    />
                  </>
                )
              })}
            </div>
          </Grid>

          <Grid item sm={12} md={12} lg={7}>
            <div className="Accordion__Content-Right">
              {mtvData.map((tabs, index: number) => {
                const tabImgPath: string = tabs?.media?.image?.file?.url || ''
                const tabImgAlt: string = tabs?.media?.altText || ''

                return (
                  <AccordionImage
                    id={index}
                    isOpen={activeIndex === index}
                    tabImgAlt={tabImgAlt}
                    tabImgPath={tabImgPath}
                    mainImgPath={mainImgPath}
                    mainImgAlt={mainImgAlt}
                  />
                )
              })}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
